import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import PersonalInfo from './PersonalInfo';
import WorkHistory from './WorkHistory';
import ClinicalTrialExp from './ClinicalTrialExp';
import Education from './Education';
import TrainingExp from './TrainingExp';
import SystemExp from './SystemExp';
import Licence from './Licence';
import Language from './Language';
import CurriculumVitaeFilter from './CurriculumVitaeFilter';
import CurriculumVitaeCenter from './CurriculumVitaeCenter';
import { UpdateLog } from './Widget';
import '../style/vitae.less';
import { saveParams } from '../../../actions/PersonalActions';

const { TabPane } = Tabs;

class CurriculumVitae extends Component {
    constructor(props) {
        super(props);
        const { params: { isChinese,vitaeName,canEdit } } = this.props;
        this.state = {
            panes: [{
                title: '个人信息',
                key: 'personalInfo',
                content: null,
                en: 'Personal Profile',
            }, {
                title: '工作经历',
                key: 'workHistory',
                content: null,
                en: 'Work History',
            }, {
                title: '临床试验经验',
                key: 'clinicalTrialExp',
                content: null,
                en: 'Clinical Trial Experience',
            }, {
                title: '教育背景',
                key: 'education',
                content: null,
                en: 'Education',
            }, {
                title: '培训经历',
                key: 'trainingExp',
                content: null,
                en: 'Training Experience',
            }, {
                title: '使用系统经验',
                key: 'systemExp',
                content: null,
                en: 'System Experience',
            }, {
                title: '执照/许可证/证书',
                key: 'licence',
                content: null,
                en: 'Licences/Certificates',
            }, {
                title: '语言/流利度',
                key: 'language',
                content: null,
                en: 'Languages/Fluency',
            }],
            activeKey: 'personalInfo',
            filterVisible: false,
            isChinese,
            vitaeName,
            canEdit
        }
    }

    componentDidMount() {
        this.updatePanes();
        this.showResumeCenter();
    }

    handleBtnClick = (e, isChinese) => {
        this.setState({
            isChinese,
            vitaeName:''
        }, () => {
            this.updatePanes();
        });
    }

    showResumeCenter = ()=>{
        const { vitaeName } = this.state; 
        const {params:{showModal,relateId}}= this.props;
        if(showModal){
            this.centerRef.show(vitaeName,relateId);
            this.props.saveParams({
                showModal :false,
            });
        }
    }


    updatePanes = () => {
        const { params: { userId, canEdit } } = this.props;
        const { panes, activeKey, isChinese } = this.state;
        let RenderContent = null;
        if (activeKey == 'personalInfo') {
            RenderContent = PersonalInfo;
        } else if (activeKey == 'workHistory') {
            RenderContent = WorkHistory;
        } else if (activeKey == 'clinicalTrialExp') {
            RenderContent = ClinicalTrialExp;
        } else if (activeKey == 'education') {
            RenderContent = Education;
        } else if (activeKey == 'trainingExp') {
            RenderContent = TrainingExp;
        } else if (activeKey == 'systemExp') {
            RenderContent = SystemExp;
        } else if (activeKey == 'licence') {
            RenderContent = Licence;
        } else if (activeKey == 'language') {
            RenderContent = Language;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent userId={userId} canEdit={canEdit} isChinese={isChinese} />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.updatePanes();
        });
    }

    showFilter = (filterVisible) => {
        this.setState({ filterVisible });
    }

    curriculumVitaeCenter = () => {
        const vitaeName = null;
        this.centerRef.show(vitaeName);
    }

    showLog = () => {
        this.logRef.show();
    }

    leave = () => {
        const { params: { userId } } = this.props
        this.props.saveParams({
            folderUserId: userId,
        });
        window.history.go(-1);
    }

    render() {
        const { type, params: { userId, canEdit, userName ,relateId} } = this.props;
        const { panes, activeKey, isChinese, filterVisible,vitaeName } = this.state;
        if (!userId) {
            if (type === 'user') {
                return <Redirect to="/user/userResume" />
            } else if (type === 'personal') {
                return <Redirect to="/personal/curriculumVitae" />
            }
        }
        return (
            <div className="curriculumVitae">
                {
                    type === 'user' &&
                    <div style={{ overflow: 'hidden', marginBottom: 10 }}>
                        <div style={{ float: 'left', marginLeft: 10 }}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                            >&#xe65b;</i>
                            {userName}的简历
                        </div>
                        <div style={{ float: 'right', marginRight: 10, color: '#1296DB', cursor: 'pointer' }} onClick={this.leave}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px' }}
                            >&#xe63d;</i>
                            返回
                        </div>
                    </div>
                }
                <div className="tab_flex" style={{marginBottom: 20}}>
                    <a className={isChinese ? "curr" : ""} onClick={e => this.handleBtnClick(e, true)} >中文简历</a>
                    <a className={!isChinese ? "curr" : ""} onClick={e => this.handleBtnClick(e, false)} >英文简历</a>
                </div>
                <div style={{ marginBottom: 10, textAlign: 'right' }}>
                    <a onClick={this.showLog}>更新日志</a>
                    <span className="ant-divider" />
                    <a onClick={() => this.showFilter(true)}>生成简历</a>
                    <span className="ant-divider" />
                    <a onClick={this.curriculumVitaeCenter}>简历中心</a>
                </div>
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={isChinese ? pane.title : pane.en} key={pane.key}>{pane.content}</TabPane>)}
                </Tabs>
                <CurriculumVitaeFilter type={type} showFilter={this.showFilter} filterVisible={filterVisible} isChinese={isChinese} userId={userId} />
                <CurriculumVitaeCenter ref={el => this.centerRef = el} userId={userId} canEdit={canEdit} isChinese={isChinese} vitaeName={vitaeName} relateId={relateId}/>
                <UpdateLog ref={el => this.logRef = el} ownerId={userId} isChinese={isChinese} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { personalState: { params, queryParams } } = state;
    return {
        params,
        queryParams,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CurriculumVitae);


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/index.js